import './App.css';
import Header from './components/Header';
import DataProvider from "./components/DataProvider";
import Magicpen from './components/Magicpen';
import About from './components/About';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './components/authentication/Login';
import Signup from './components/authentication/Signup';
import Home from './components/Home';

function App() {
  return (
    <DataProvider>
      <>
        <BrowserRouter>
          <Routes>
            <Route path='/login' element={<Login />} />
            <Route path='/sign-up' element={<Signup />} />
            <Route path='/' element={<Header />} >
              <Route index element={<Home />} />
              <Route path='/magicpen/:penId' element={<Magicpen />} />
              <Route path='about' element={<About />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </>
    </DataProvider>
  );
}

export default App;
